import React, { useEffect, useState } from "react";
import axiosConfig from "../Service/axiosConfig";
import { PopupModal } from "../Components";
import Select from "react-select";
import { useNavigate, useParams } from "react-router";

import { MarketingNavbarComponent } from "../Components/navbar/marketingnav";

const CategoryGroupingAdd = () => {
    let { id } = useParams();
    const [popupType, setpopupType] = useState("");
    const [message, setMessage] = useState("");
    const [Error, SetError] = useState("");
    const [subcategoryOptions, setSubcategoryOptions] = useState([]);
    const [promotionalCategoryOptions, setPromotionalCategoryOptions] = useState([]);
    const [existingSlug, setExistingSlug] = useState(null);
    const [slugManual, setSlugManual] = useState(false);
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        group_code: "",
        sort: "",
        category: [],
        promotional_category: []
    });

    const handleFormChange = (e) => {
        const { name, value } = e.target;
        console.log(formData, "inside handleFormChange");
        if (name === "slug") {
            setSlugManual(true);
        }
        if (name === "name" && !existingSlug && !slugManual) {
            console.log("inside slug auto generate");
            const auto_slug = value;
            const trimmedName = auto_slug.trim();
            const slug = trimmedName.replace(/[\/\s,&]+/g, "-").toLowerCase();
            setFormData({ ...formData, [name]: value, slug: slug });
        } else {
            setFormData({ ...formData, [name]: value });
        }
        if (name === "track_inventry") {
            setFormData({
                ...formData,
                track_inventry: formData.track_inventry === false ? true : false,
            });
        }
    };

    const formSubmit = (event) => {
        console.log(formData, "inside formSubmit");
        event.preventDefault();

        const payload = {
            title: formData.title,
            description: formData.description,
            group_code: formData.group_code,
            sort: formData.sort ? parseInt(formData.sort, 10) : null,
            category: formData.category.map((cat) => cat.value),
            promotional_category: formData.promotional_category.map((pc) => pc.value),
        };

        if (id) {
            console.log(payload, "inside form submit - patch");
            axiosConfig
                .patch(`/cms/category_grouping/${id}/`, payload)
                .then((res) => {
                    console.log(res);
                    setMessage("Category Grouping Updated Successfully");
                    setpopupType("success");
                    SetError("");
                })
                .catch((error) => {
                    console.log(error);
                    setpopupType("error");
                });
        } else {
            axiosConfig
                .post(`/cms/category_grouping/`, payload)
                .then((res) => {
                    console.log(res, "category grouping created");
                    const newGroupId = res.data.id;
                    // After creation, add to homepage template
                    return axiosConfig
                        .post(`/cms/homepage_template/40/add_items/`, {
                            item_type: "category_grouping",
                            item_ids: [newGroupId],
                        })
                        .then(() => {
                            setMessage("Category Grouping Created and Added to Homepage Successfully");
                            setpopupType("success");
                            SetError("");
                        })
                        .catch((err) => {
                            console.log("Error adding to homepage template:", err);
                            // Still show success for grouping creation even if homepage link fails
                            setMessage("Category Grouping Created Successfully (homepage link failed)");
                            setpopupType("success");
                            SetError("");
                        });
                })
                .catch((error) => {
                    console.log(error);
                    if (error.response && error.response.data && error.response.data.error) {
                        SetError(error.response.data.error);
                    }
                    setpopupType("error");
                });
        }
    };
    const catedit = () => {
        axiosConfig
            .get(`/cms/category_grouping/${id}/`)
            .then((res) => {
                const data = res.data.results ? res.data.results[0] : res.data;
                const resolvedCategories = (data.category || [])
                    .filter((cat) => !cat.is_promotional_category)
                    .map((cat) => ({
                        value: cat.id,
                        label: cat.name,
                    }));
                const resolvedPromoCategories = (data.promotional_category || []).map((pc) => ({
                    value: pc.id,
                    label: pc.title || pc.name,
                }));
                setFormData({
                    title: data.title || "",
                    description: data.description || "",
                    group_code: data.group_code || "",
                    sort: data.sort !== undefined && data.sort !== null ? String(data.sort) : "",
                    category: resolvedCategories,
                    promotional_category: resolvedPromoCategories,
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };


    const [Branddata, setBranddata] = useState([]);
    async function fetchAllData() {
        const response = await axiosConfig.get(
            `/cms/category_grouping/?page_size=1000&is_suspended=false`
        );
        setBranddata(response.data.results);
    }

    useEffect(() => {
        if (id) {
            catedit();
        }
        const fetchCategories = async () => {
            const response = await axiosConfig.get(
                `/catlog/categories/?is_promotional_category=false&page_size=300&is_suspended=false`
            );
            setSubcategoryOptions(response.data.results);
        };
        const fetchPromoCategories = async () => {
            const response = await axiosConfig.get(
                `/cms/promotional_category/?is_suspended=false&page_size=300`
            );
            setPromotionalCategoryOptions(response.data.results);
        };
        fetchCategories();
        fetchPromoCategories();
        fetchAllData();
    }, [id]);


  
    const handleMultiSelectChange = (selectedOption, name) => {
        setFormData(prev => ({ 
            ...prev, 
            [name]: selectedOption ? selectedOption.map(res => ({ value: res.value, label: res.label })) : [] 
        }));
    };
    

    let navigate = useNavigate();
    const HandleNavigate = () => {
        navigate(-1);
    };
    console.log(localStorage.getItem("site_data"));

    return (
        <div className="child-sidenav">
            <MarketingNavbarComponent />
            <div className="childnav-content">
                <form onSubmit={(e) => formSubmit(e)}>
                    <div className="dashboard-header">
                        <h5 className="dashboard-subtitle">
                            {id ? "Edit Item" : "Add Item"}
                        </h5>
                        <div className="mx-4">
                            <button
                                type="submit"
                                className="btn btn btn-white"
                                onClick={HandleNavigate}
                            >
                                Cancel
                            </button>
                        </div>
                        <div>
                            <button type="submit" className="btn btn btn-primary">
                                Submit
                            </button>
                        </div>
                    </div>

                    <div className="row align-items-center mt-2">
                        <div className="col-4">
                            <div className="form-field">
                                <label htmlFor="title">Title:</label>
                                <sup className="sup-colour">*</sup>
                                <input
                                    type="text"
                                    id="title"
                                    name="title"
                                    className="form-control"
                                    value={formData.title}
                                    onChange={(e) => handleFormChange(e)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="col-4">
                            <div className="form-field">
                                <label htmlFor="description">Description:</label>
                                <input
                                    type="text"
                                    id="description"
                                    name="description"
                                    className="form-control"
                                    value={formData.description}
                                    onChange={(e) => handleFormChange(e)}
                                />
                            </div>
                        </div>

                        <div className="col-4">
                            <div className="form-field">
                                <label htmlFor="group_code">Group Code:</label>
                                <sup className="sup-colour">*</sup>
                                <input
                                    type="text"
                                    id="group_code"
                                    name="group_code"
                                    className="form-control"
                                    value={formData.group_code}
                                    onChange={(e) => handleFormChange(e)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="col-4">
                            <div className="form-field">
                                <label htmlFor="sort">Sort Order:</label>
                                <input
                                    type="number"
                                    id="sort"
                                    name="sort"
                                    className="form-control"
                                    value={formData.sort}
                                    onChange={(e) => handleFormChange(e)}
                                />
                            </div>
                        </div>

                        <div className="col-4">
                            <div className="form-field">
                                <label htmlFor="Category">Category:</label>{" "}
                                <sup className="sup-colour">*</sup>
                                <Select
                                    isMulti
                                    options={subcategoryOptions.map(res => ({
                                        value: res.id,
                                        label: res.name,
                                    }))}
                                    value={formData.category}
                                    onChange={(selectedOption) => handleMultiSelectChange(selectedOption, "category")}
                                    placeholder="Select Category"
                                />
                            </div>
                        </div>

                        <div className="col-4">
                            <div className="form-field">
                                <label htmlFor="promotional_category">Promotional Category:</label>
                                <Select
                                    isMulti
                                    options={promotionalCategoryOptions.map(res => ({
                                        value: res.id,
                                        label: res.title || res.name,
                                    }))}
                                    value={formData.promotional_category}
                                    onChange={(selectedOption) => handleMultiSelectChange(selectedOption, "promotional_category")}
                                    placeholder="Select Promotional Category"
                                />
                            </div>
                        </div>

                    </div>
                </form>
            </div >
            {popupType !== "" && (
                <PopupModal
                    setpopupType={setpopupType}
                    popupType={popupType}
                    Message={message}
                    Navigation={-1}
                    error={Error}
                />
            )}

        </div >
    );
};
export default CategoryGroupingAdd;
